import Vue from 'vue';
import Api from '@/utils/api';
import DatePicker from 'vue2-datepicker';

import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment.js';
import Font from '@ckeditor/ckeditor5-font/src/font';
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading';

export default Vue.extend({
  name: 'Notifications',
  components: {
    DatePicker,
  },
  data() {
    return {
      editorLoaded: false,
      edit: false,
      duplicate: false,
      newNotification: null,
      notificationList: [],
      test: '',
      //
      editor: ClassicEditor,
      editorData: '<p>Content of the editor.</p>',
      editorConfig: {
        plugins: [
          EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          LinkPlugin,
          ParagraphPlugin,
          Alignment,
          Font,
          HeadingPlugin,
        ],

        toolbar: {
          items: [
            'heading',
            'bold',
            'italic',
            'link',
            '|',
            'alignment:left',
            'alignment:center',
            'alignment:right',
            'alignment:justify',
            '|',
            'fontSize',
            'fontFamily',
            'fontColor',
            'fontBackgroundColor',
          ],
        },
      },
    };
  },
  methods: {
    getAllNotifications() {
      Api.settings.notifications
        .getNotifications()
        .then((res) => {
          if (res.status === 200 || res.status === 204) {
            this.notificationList = res.data;
            this.notificationList.forEach((el) => {
              el.StartDate = new Date(el.StartDate * 1000);
              el.EndDate = new Date(el.EndDate * 1000);
            });
          }
        })
        .catch((err) => {
          this.$root.$emit('notification', {
            message: `error | ${err.Message}`,
            type: 'error',
            show: true,
          });
        });
    },
    addNotification() {
      this.edit = false;
      this.newNotification = {
        Name: '',
        Message: '',
        StartDate: new Date(),
        EndDate: new Date(),
      };
    },
    submitNotification() {
      this.newNotification.StartDate =
        this.newNotification.StartDate.getTime() / 1000;

      this.newNotification.EndDate =
        this.newNotification.EndDate.getTime() / 1000;
      const action = this.newNotification.hasOwnProperty('ID') ? 'edit' : 'add';

      if (action === 'edit') {
        Api.settings.notifications
          .updateNotification(this.newNotification)
          .then((res) => {
            if (res.status == 200 || res.status === 204) {
              this.$root.$emit('notification', {
                message: 'Notification has been edited',
                type: 'info',
                show: true,
              });
              this.getAllNotifications();
              this.newNotification = null;
            }
          })
          .catch((err) => {
            this.$root.$emit('notification', {
              message: `error | ${err.Message}`,
              type: 'error',
              show: true,
            });
          });
      }
      if (action === 'add') {
        Api.settings.notifications
          .addNotification(this.newNotification)
          .then((res) => {
            if (res.status == 200 || res.status === 204) {
              this.$root.$emit('notification', {
                message: 'new notification added',
                type: 'info',
                show: true,
              });
              this.getAllNotifications();
              this.newNotification = null;
            }
          })
          .catch((err) => {
            this.$root.$emit('notification', {
              message: `error | ${err.Message}`,
              type: 'error',
              show: true,
            });
          });
      }
    },
    canselAddNotification() {
      this.newNotification = null;
    },
    confirmRemove(notification) {
      this.$modal.show('dialog', {
        title: '<i class="fa fa-trash" aria-hidden="true"></i>',
        text: 'Do you really want to remove this notification from the list? <br/> this action cannot be undone',
        buttons: [{
          title: 'Yes',
          handler: () => {
            this.removeNotification(notification);
            this.$modal.hide('dialog');
          },
        },
        {
          title: 'No',
        },
        ],
      });
    },
    removeNotification(notification) {
      Api.settings.notifications
        .removeNotification(notification)
        .then((res) => {
          if (res.status === 200 || res.status === 204) {
            this.$root.$emit('notification', {
              message: 'notification is removed',
              type: 'info',
              show: true,
            });
            this.getAllNotifications();
          }
        })
        .catch((err) => {
          this.$root.$emit('notification', {
            message: `error | ${err.Message}`,
            type: 'error',
            show: true,
          });
        });
    },
    editNotification(notification) {
      this.edit = true;
      this.duplicate = false;
      this.newNotification = Object.assign({}, notification);
    },
    duplicateNotification(notification) {
      this.edit = false;
      this.duplicate = true;
      this.newNotification = {
        ...notification,
        Name: notification.Name.trim().concat(' (copy)'),
      };
      delete this.newNotification.ID;
    },
  },
  created() {
    this.getAllNotifications();
  },
});
